<template>
  <div v-if="NOTARIA">
    <!-- Plantillas 2 a 5: cabecera de página de la plantilla -->
    <N2CabezaPagina v-if="!acceso.esAgregador.value && disenoPropio" :titulo="titulo" :imagen="banner.Imagen" :filtro="banner.ImagenFiltro" />
    <SliderBannerNotinTwo v-else-if="!acceso.esAgregador.value" :obj="banner" type="servicios" />

    <div :class="acceso.esAgregador.value ? 'tramite-seo-fondo tramite-seo-fondo--portal' : 'tramite-seo-fondo rn-section-gap bg_color--1'">
      <v-container>
        <v-row>
          <v-col cols="12" md="10" lg="8" class="mx-auto">
            <h1 v-if="acceso.esAgregador.value" class="tramite-seo__titulo">{{ t('Trámites online') }}</h1>
            <p class="tramite-seo__intro">{{ t('Elija el trámite que necesita y prepárelo online con la notaría.') }}</p>

            <ul class="tramites-lista">
              <li v-for="x in lista" :key="x.slug">
                <NuxtLink :to="getLocalePath('/tramites/' + x.slug)" class="tramites-lista__item">
                  <v-icon size="30" class="tramites-lista__icono">{{ x.icono }}</v-icon>
                  <span class="tramites-lista__nombre">{{ x.nombre }}</span>
                  <span class="tramites-lista__texto">{{ x.descripcion }}</span>
                  <span v-if="videoconferenciaEn(x.codigo)" class="tramites-lista__video">
                    <v-icon size="16">mdi-video-outline</v-icon> {{ t('Se puede firmar por videoconferencia') }}
                  </span>
                  <span class="tramites-lista__ir">{{ t('Más información') }} <v-icon size="16">mdi-arrow-right</v-icon></span>
                </NuxtLink>
              </li>
            </ul>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script setup lang="ts">
import N2CabezaPagina from '../../components/notaria2/N2CabezaPagina.vue'
import { useDisenoPropio } from '../../composables/useNotaria2'
const disenoPropio = useDisenoPropio()
import { computed } from 'vue'
import { useStore } from '../../store/index'
import { useAccesoSolicitud } from '../../composables/solicitudAcceso'
import { useSolicitudWeb } from '../../composables/useSolicitudWeb'
import { useSeoUrls } from '../../composables/useSeoUrls'
import { t } from '../../composables/solicitudTextos'
import { TRAMITES_SEO } from '../../data/tramitesSeo'
import { useUtils } from '#imports'

// Índice de las páginas informativas de trámites. Ref: https://trello.com/c/p3o83iNG
const store = useStore()
const { NOTARIA } = storeToRefs(store)
const acceso = useAccesoSolicitud()
const seo = useSeoUrls()
const { getLocalePath } = useUtils()
const { tipos, cargarCatalogo, videoconferenciaEn } = useSolicitudWeb()

if (!acceso.paginasTramite.value) {
  throw createError({ statusCode: 404, statusMessage: 'Page Not Found', fatal: true })
}
await cargarCatalogo()

const lista = computed(() => TRAMITES_SEO
  .map((x) => ({ slug: x.slug, ...(tipos.value.find((tp: any) => tp.codigo === x.codigo) ?? null) }))
  .filter((x: any) => x.nombre) as { slug: string; nombre: string; descripcion: string; icono: string; codigo: string }[])

const titulo = t('Trámites online')
const descripcion = t('Elija el trámite que necesita y prepárelo online con la notaría.')
const banner = computed(() => {
  const base: any = NOTARIA.value?.Theme?.Servicios ?? {}
  return { ...base, Titulo: { ...base.Titulo, Texto: titulo }, Subtitulo: { ...base.Subtitulo, Texto: '' }, ShowButton: false }
})

useMetaTags(toRaw(NOTARIA.value), 'Tramites', undefined, {
  title: titulo,
  description: descripcion,
  seccion: titulo
})
</script>

<style lang="scss">
.tramites-lista { list-style: none; padding: 0; margin: 28px 0 0; display: grid; grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); gap: 16px;
  &__item { display: flex; flex-direction: column; gap: 6px; height: 100%; padding: 22px; border-radius: 14px; background: #f5f7f9; border: 1px solid #e3e7ea;
    color: #1d2329 !important; text-decoration: none !important; &:hover, &:focus-visible { border-color: rgb(var(--v-theme-primary)); } }
  &__icono { color: rgb(var(--v-theme-primary)) !important; }
  &__nombre { font-size: 1.1rem; font-weight: 600; }
  &__texto { color: #5f6b76; flex: 1; }
  &__video { display: inline-flex; align-items: center; gap: 6px; font-size: 0.85rem; color: #1f3b52;
    .v-icon { color: rgb(var(--v-theme-primary)) !important; } }
  &__ir { font-weight: 600; color: rgb(var(--v-theme-primary)); }
}
</style>
